/** TypeScript mirror of /schema/document.schema.json. Hand-maintained;
 *  if it drifts from the Python pydantic model, the verify CLI catches it. */

export type PostType =
  | "sc_resort"
  | "holiday"
  | "sc_event"
  | "ski-test"
  | "post"
  | "sc_community_post"
  | "page"
  | "sc_discount"
  | "affiliates_discount"
  | "product"
  | "sc_rep";

export interface SearchDocAttrs {
  price?: number;
  price_text?: string;
  event_date?: number;
  event_date_text?: string;
  discount_overview?: string;
  country?: string;
  ski_ability?: string;
  product_categories?: string[];
  in_stock?: boolean;
  is_rep_resort?: boolean;
  tour_ids?: string[];
  product_key?: string;
  next_departure?: string;
  departure_months?: string[];
}

export interface SearchDoc {
  id: string;
  post_id: number;
  post_type: PostType;
  type_rank: number;
  title: string;
  slug: string;
  url: string;
  excerpt: string;
  body: string;
  image_url: string;
  image_alt: string;
  date_published: number;
  date_modified: number;
  taxonomies: Record<string, string[]>;
  attrs: SearchDocAttrs;
  schema_version: "1.0.0";
}

/** Tab → post_type filter for the results page. Mirrors the legacy tabs. */
export const TAB_MAP: Record<string, PostType[] | null> = {
  all: null,
  pages: ["page"],
  resorts: ["sc_resort"],
  holidays: ["holiday"],
  events: ["sc_event"],
  "ski-tests": ["ski-test"],
  news: ["post", "sc_community_post"],
  discounts: ["sc_discount", "affiliates_discount"],
  products: ["product"],
};

/** Placeholder noun for a scope-locked element, keyed by TAB_MAP key. */
export const SCOPE_LABEL: Record<string, string> = {
  pages: "pages",
  resorts: "resorts",
  holidays: "holidays",
  events: "events",
  "ski-tests": "ski tests",
  news: "news",
  discounts: "discounts",
  products: "products",
};

export const POST_TYPE_LABEL: Record<PostType, string> = {
  sc_resort: "Resort",
  holiday: "Holiday",
  sc_event: "Event",
  "ski-test": "Ski Test",
  post: "News",
  sc_community_post: "News",
  page: "Page",
  sc_discount: "Discount",
  affiliates_discount: "Discount",
  product: "Shop",
  sc_rep: "Rep",
};
